import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Search from '@mui/icons-material/Search';
import Stack from '@mui/material/Stack';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchArticles } from '../strapi';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';

function Documentation({ content , locale}) {
    let searchPlaceholder = locale == 'ru' ? 'Поиск' : 'Search';
    let loading = locale == 'ru' ? 'Загрузка...' : 'Loading...';
    const [query, setQuery] = useState('');
    const [results, setResults] = useState([]);
    const [searching, setSearching] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10); // Number of results per page
    const [total, setTotal] = useState(0);
    const [anchorElSaved, setAnchorElSaved] = useState(null);
    const navigate = useNavigate();
    const handleSearch = async (event, pageArg = 1) => {

        const q = (query || '').trim();
        if (!q) {
            setResults([]);
            setAnchorEl(null);
            setTotal(0);
            return;
        }
        setSearching(true);
        setAnchorEl(event?.currentTarget || anchorEl);


        try {
            // Assuming your searchArticles supports pagination
            const data = await searchArticles(q, locale, pageArg, pageSize);
            // If your API returns meta.pagination, use it for total count
            const items = data.data.data;
            setResults(items);
            //console.log("total: ", data.meta?.pagination?.total);
            setTotal(data.meta?.pagination?.total || items.length);
        } catch (err) {
            console.error('Search error', err);
            setResults([]);
            setTotal(0);
        } finally {
            setSearching(false);
        }
    };

    const handlePageChange = async (event, value) => {
        setPage(value);
        await handleSearch(anchorElSaved, value);
        // setAnchorEl(event.currentTarget)
    };

    // Reset page to 1 on new query
    React.useEffect(() => {
        setPage(1);
    }, [query]);

    const handleResultClick = (item) => {
        if (item.documentId) {
            if (item.resource === 'products' || item.resource === 'news') {
                navigate(`/${item.resource}/${item.documentId}`);
            }
            else if (item.resource === 'main-pages') {
                setQuery('');
                setSearching(false);
                setResults([]);
                navigate(`/`);

            }
            else { navigate(`/${item.resource}`); }
        }

        setAnchorEl(null);
    };
     const closeSearch = () => {
        setAnchorEl(null);
        setQuery('');
        setSearching(false);
        setResults([]);
    };

    return (
        <div >
            <Container sx={{ alignItems: 'center' }}>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {/* {content?.title || ''} */}
                </Typography>
                <Box sx={{
                    p: 5,
                    borderRadius: 10,
                    bgcolor: '#2D5B96',
                }}>
                    <Typography gutterBottom variant="h4" sx={{ fontWeight: 'bold' }} align='center' component="div">
                        {content?.text || ''}
                    </Typography>
                    <Link to='/products/0'>
                        <Typography gutterBottom variant="h4" sx={{ fontWeight: 'bold', textDecoration: 'underline'  }} align='center' component="div" color='#fff'>
                            {(content?.someText?.[0].body) || ''}
                        </Typography>
                    </Link>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        <Box sx={{ bgcolor: '#ffffff', width: '80%', height: '60px', borderRadius: '70px', p: 1.5, m: 3 }} className='search'>
                            <Stack direction="row" sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                {/* <input className='my_input' placeholder={search} style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent' }}/> */}
                                {/* <Box sx={{ bgcolor: '#2D5B96', borderRadius: '45px', alignItems: 'center', justifyContent: 'center', p: 2, width: '35px', height: '100%' }}><Search sx={{ color: '#ffffff', fontSize: 30, }}></Search></Box> */}
                                <input
                                    className='my_input'
                                    value={query}
                                    placeholder={searchPlaceholder}
                                    onChange={e => setQuery(e.target.value)}
                                    onKeyDown={e => { if (e.key === 'Enter') handleSearch(e); setAnchorElSaved(e) }}
                                    style={{ width: '100%', border: 'none', outline: 'none', background: 'transparent' }}
                                />
                                <Box
                                    onClick={(e) => { handleSearch(e); setAnchorElSaved(e) }}
                                    sx={{ bgcolor: '#2D5B96', borderRadius: '50px', alignItems: 'center', justifyContent: 'center', p: 2, width: '35px', height: '35px', cursor: 'pointer' }}>
                                    <Search sx={{ color: '#ffffff', fontSize: 20, width: '35px', height: '35px', }} />
                                </Box>

                                <Menu
                                                anchorEl={anchorEl}
                                                open={(anchorEl) && (searching || results.length > 0 || (query && results.length === 0))}
                                                onClose={() => closeSearch()}
                                            >
                                                {searching && (
                                                    <MenuItem disabled>
                                                        <Typography variant="body2">{loading}</Typography>
                                                    </MenuItem>
                                                )}
                                                {!searching && results?.length > 0 && results.map((item, idx) => (
                                                    <MenuItem
                                                        key={idx}
                                                        onClick={() => handleResultClick(item)}
                                                        sx={{ alignItems: 'flex-start', whiteSpace: 'normal' }}
                                                    >
                                                        <Box>
                                                            <Typography variant="subtitle2">
                                                                {item.attributes?.title || item.title || '-'}
                                                            </Typography>
                                                            <Typography variant="body2" color="text.secondary">
                                                                {(() => {
                                                                    const context = item.attributes?.context || item.context || '';
                                                                    const queryLower = query.toLowerCase();
                                                                    const contextLower = context.toLowerCase();
                                                                    const idxFound = contextLower.indexOf(queryLower);
                                                                    if (idxFound === -1 || !query) return context;
                                                                    return (
                                                                        <>
                                                                            {context.slice(0, idxFound)}
                                                                            <b>{context.slice(idxFound, idxFound + query.length)}</b>
                                                                            {context.slice(idxFound + query.length)}
                                                                        </>
                                                                    );
                                                                })()}
                                                            </Typography>
                                                        </Box>
                                                    </MenuItem>
                                                ))}
                                                {!searching && results?.length === 0 && query && (
                                                    <MenuItem disabled>
                                                        <Typography variant="body2">{locale === 'ru' ? 'Ничего не найдено' : 'No results'}</Typography>
                                                    </MenuItem>
                                                )}
                                                {/* Paging controls */}
                                                {!searching && total > pageSize && (
                                                    <MenuItem disableRipple sx={{ justifyContent: 'center' }}>
                                                        <Pagination
                                                            className='pagination'
                                                            sx={{ color: "#5281B5", justifyContent: 'center' }}
                                                            color="primary"
                                                            count={Math.ceil(total / pageSize)}
                                                            page={page}
                                                            onChange={handlePageChange}
                                                            size="small"
                                                        />
                                                    </MenuItem>
                                                )}
                                            </Menu>
                            </Stack>
                        </Box>
                    </Box>
                </Box>
            </Container>
        </div>
    );
}
export default Documentation;
